import {
  ApiResponsePublishedTournaments,
  ApiResponseMiniLeaderboardData,
  ApiResponseTournamentData,
  ApiResponseTournamentLeaderboardList,
  MiniLeaderboardTournament,
  PublishedTournament,
} from 'src/app/core/api/wager-api';
import { GameId } from 'src/app/model/game/game-id';

/** Tournament State Logic
 * Finished           :- finished: true
 * CollectingResults  :- now > joinUntilDate
 * JoinOnly           :- now > endDate
 * Live               :- now > startDate
 * NotStarted         :- _else
 */

const timeGap = 1000 * 60 * 59; // 59 minutes
const currDate = new Date().getTime();
const futureDate = currDate + timeGap;
const pastDate = currDate - timeGap;
const tournamentRoundDeadline = currDate + 1000 * 60 * 2;

const MOCK_TOURNAMENTS: PublishedTournament[] = [
  {
    entries: [],
    tournament: {
      tournamentId: '7cd17771-3fab-4619-8d2c-a2d8dca7a593',
      scoreFormula: 'SUM_OF_WON_CENTS',
      title: 'Clinch Tournament',
      bannerUrl: 'https://storage.googleapis.com/clinch-tournaments/banners/test-banner-1.jpg',
      roundDeadline: tournamentRoundDeadline,
      gameIds: [GameId.Solitaire],
      leaderboard: {
        prizes: [
          {
            count: 1,
            amount: 100,
          },
          {
            count: 2,
            amount: 50,
          },
          {
            count: 3,
            amount: 20,
          },
        ],
      },
      ...getNotStartedStatus(),
    },
  },
  {
    entries: [
      {
        nick: 'Jack',
        score: 1234343,
        userId: '1d23dfs',
      },
      {
        nick: 'Jack1',
        score: 1233,
        userId: '1d23dfs',
      },
      {
        nick: 'Jack2',
        score: 12,
        userId: '1d23dfs',
      },
    ],
    tournament: {
      tournamentId: '7b920d5a-3fc3-426b-9c93-4869e4692513',
      scoreFormula: 'SUM_OF_WON_CENTS',
      title: 'Clinch Tournament #2',
      bannerUrl: 'https://picsum.photos/id/20/1080/720',
      roundDeadline: 1765325640000,
      gameIds: [GameId.Solitaire],
      leaderboard: {
        prizes: [
          {
            count: 1,
            amount: 100,
          },
          {
            count: 2,
            amount: 50,
          },
          {
            count: 3,
            amount: 20,
          },
        ],
      },
      ...getLiveStatus(),
    },
  },
  {
    entries: [
      {
        nick: 'Jack',
        score: 123,
        userId: '1d23dfs',
      },
    ],
    tournament: {
      tournamentId: '7b25d818-079c-47f8-96a5-914889faa3b2',
      scoreFormula: 'SUM_OF_WON_CENTS',
      title: 'Clinch Tournament #1',
      bannerUrl: 'https://placehold.co/600x174/000000/FFF',
      roundDeadline: 1765325640000,
      gameIds: [GameId.Solitaire],
      leaderboard: {
        prizes: [
          {
            count: 1,
            amount: 100,
          },
          {
            count: 2,
            amount: 50,
          },
          {
            count: 3,
            amount: 20,
          },
        ],
      },
      ...getJoinUntilStatus(),
    },
  },
  {
    entries: [
      {
        nick: 'Jack',
        score: 123,
        userId: '1d23dfs',
      },
    ],
    tournament: {
      tournamentId: '29f9f4a2-3021-46e1-9515-b417ee7542d6',
      scoreFormula: 'SUM_OF_WON_CENTS',
      title: 'Clinch Tournament #4',
      bannerUrl: 'https://placehold.co/600x174/000000/FFF',
      roundDeadline: 1739146440000,
      gameIds: [GameId.Solitaire],
      leaderboard: {
        prizes: [
          {
            count: 1,
            amount: 100,
          },
          {
            count: 2,
            amount: 50,
          },
          {
            count: 3,
            amount: 20,
          },
        ],
      },
      ...getCollectingResultsStatus(),
    },
  },
  {
    entries: [
      {
        nick: 'Jack',
        score: 123,
        userId: '1d23dfs',
      },
    ],
    tournament: {
      tournamentId: 'a166da32-d117-48be-a1dd-0c316604ca49',
      scoreFormula: 'SUM_OF_WON_CENTS',
      title: 'Clinch Tournament #4',
      bannerUrl: 'https://placehold.co/600x174/000000/FFF',
      roundDeadline: 1739146440000,
      gameIds: [GameId.Solitaire],
      leaderboard: {
        prizes: [
          {
            count: 1,
            amount: 100,
          },
          {
            count: 2,
            amount: 50,
          },
          {
            count: 3,
            amount: 20,
          },
        ],
      },
      ...getFinishedStatus(),
    },
  },
];

const MOCK_LEADERBOARD_LIST = [
  { nick: 'Jack', score: 1000, userId: '1d23dfs' },
  { nick: 'Mia', score: 950, userId: '15r67stu' },
  { nick: 'Olivia', score: 900, userId: '5g67opq' },
  { nick: 'Alexander', score: 850, userId: '12n34jkl' },
  { nick: 'Ava', score: 800, userId: '7i89uvw' },
  { nick: 'Sophia', score: 750, userId: '3e45ijk' },
  { nick: 'Harper', score: 700, userId: '17t89yz0' },
  { nick: 'Gabriel', score: 650, userId: '34k56vwx' },
  { nick: 'Jackson', score: 600, userId: '14p56qrs' },
  { nick: 'Ella', score: 550, userId: '19v01def' },
  { nick: 'Isabella', score: 500, userId: '9k01abc' },
  { nick: 'Ethan', score: 450, userId: '8j90xyz' },
  { nick: 'Charlotte', score: 400, userId: '11m23ghi' },
  { nick: 'Liam', score: 350, userId: '4f56lmn' },
  { nick: 'Amelia', score: 300, userId: '13o45mno' },
  { nick: 'David', score: 250, userId: '30g12jkl' },
  { nick: 'James', score: 200, userId: '10l12def' },
  { nick: 'Mason', score: 150, userId: '6h78rst' },
  { nick: 'Benjamin', score: 100, userId: '20w12ghi' },
  { nick: 'Daniel', score: 50, userId: '24a56stu' },
  { nick: 'Emma', score: 25, userId: '2a34bgh' },
  { nick: 'Chloe', score: 10, userId: '27d89abc' },
  { nick: 'Zoe', score: 5, userId: '23z45pqr' },
  { nick: 'Lily', score: 1, userId: '25b67vwx' },
  { nick: 'Nora', score: 0, userId: '33j45stu' },
  { nick: 'Samuel', score: 0, userId: '32i34pqr' },
  { nick: 'Sebastian', score: 0, userId: '18u90abc' },
  { nick: 'Hannah', score: 0, userId: '29f01ghi' },
  { nick: 'Matthew', score: 0, userId: '28e90def' },
  { nick: 'Aiden', score: 0, userId: '22y34mno' },
  { nick: 'Elijah', score: 0, userId: '26c78yz0' },
  { nick: 'Grace', score: 0, userId: '31h23mno' },
  { nick: 'Amos', score: 0, userId: '21x23jkl' },
  { nick: 'Lucas', score: 0, userId: '16s78vwx' },
  { nick: 'David', score: 0, userId: '30g12jkl' },
  { nick: 'Sophie', score: 0, userId: '35l67yz0' },
  { nick: 'Evelyn', score: 0, userId: '37e89fgh' },
  { nick: 'Abigail', score: 0, userId: '38a12bcd' },
  { nick: 'Emily', score: 0, userId: '39c45def' },
  { nick: 'Madison', score: 0, userId: '40m67nop' },
  { nick: 'Scarlett', score: 0, userId: '41s89qrs' },
  { nick: 'Victoria', score: 0, userId: '42v01tuv' },
  { nick: 'Aria', score: 0, userId: '43a23wxy' },
  { nick: 'Penelope', score: 0, userId: '44p45zab' },
  { nick: 'Layla', score: 0, userId: '45l67cde' },
  { nick: 'Riley', score: 0, userId: '46r89efg' },
  { nick: 'Zoey', score: 0, userId: '47z01ghi' },
  { nick: 'Nora2', score: 0, userId: '48n23jkl' },
  { nick: 'Lillian', score: 0, userId: '49l45mno' },
  { nick: 'Addison', score: 0, userId: '50a67pqr' },
  { nick: 'Aubrey', score: 0, userId: '51a89stu' },
  { nick: 'Eleanor', score: 0, userId: '52e01vwx' },
  { nick: 'Hannah2', score: 0, userId: '53h23yz0' },
];

function getFinishedStatus() {
  return {
    startDate: currDate,
    endDate: currDate,
    joinUntilDate: currDate,
    finished: true,
  };
}

function getCollectingResultsStatus() {
  return {
    startDate: pastDate,
    endDate: pastDate,
    joinUntilDate: pastDate,
    finished: false,
  };
}

function getJoinUntilStatus() {
  return {
    startDate: pastDate,
    endDate: pastDate,
    joinUntilDate: futureDate,
    finished: false,
  };
}

function getLiveStatus() {
  return {
    startDate: pastDate,
    endDate: futureDate,
    joinUntilDate: futureDate,
    finished: false,
  };
}

function getNotStartedStatus() {
  return {
    startDate: futureDate,
    endDate: futureDate,
    joinUntilDate: futureDate,
    finished: false,
  };
}

export function getMockPublishedTournaments(): ApiResponsePublishedTournaments {
  return {
    status: 200,
    msg: 'Published tournaments',
    data: MOCK_TOURNAMENTS,
  };
}

export function getMockTournamentById(tournamentId: string): ApiResponseTournamentData {
  const tournamentData = MOCK_TOURNAMENTS.find((x) => x.tournament.tournamentId === tournamentId);
  return {
    status: 200,
    msg: 'Tournament',
    data: tournamentData?.tournament || null,
  };
}

export function getMockMiniLeaderboard(tournamentId: string): ApiResponseMiniLeaderboardData {
  const tournamentData = MOCK_TOURNAMENTS.find(
    (x) => x.tournament.tournamentId === tournamentId,
  ) as MiniLeaderboardTournament;
  return {
    status: 200,
    msg: 'Mini Leaderboard',
    data: tournamentData,
  };
}

export function getMockLeaderboardList(
  tournamentId: string,
  page: number,
): ApiResponseTournamentLeaderboardList {
  const entriesPerPage = 15;
  const startFrom = (page - 1) * entriesPerPage;
  const entries = MOCK_LEADERBOARD_LIST.slice(startFrom, startFrom + entriesPerPage);
  const hasMoreEntries = startFrom + entriesPerPage < MOCK_LEADERBOARD_LIST.length;

  return {
    status: 200,
    msg: 'Leaderboard list',
    data: {
      page,
      entriesPerPage,
      hasMoreEntries,
      entries,
    },
  };
}

export function getMockRoomTournaments() {
  return {
    status: 200,
    msg: 'Room Tournaments',
    data: MOCK_TOURNAMENTS.map((x) => x.tournament),
  };
}
